import { intl } from "../../../_metronic/i18n/i18nProvider";
import { COUNTRY_CODES } from "../../modules/profile/constants";
import { CurrencyCode, CurrencySymbol } from "./pricing.constant";

export const mappingCountryCodeToCurrency = (countryCode: COUNTRY_CODES): CurrencyCode => {
    switch (countryCode) {
        case COUNTRY_CODES.JP:
            return CurrencyCode.JPY;
        case COUNTRY_CODES.US:
            return CurrencyCode.USD;
        default:
            return CurrencyCode.USD;
    }

}
export const displayAmountBaseOnCurrency = (amount: number, currency: CurrencyCode): string => {
    if (currency === CurrencyCode.USD) {
        amount = amount / 100;
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    }).format(amount);
}